export const API_CLIENT_KEY = '4f588b2b54d0a20f79acd7f0a1325eda4d92372e1e33e6c68d3bf6948cc49702'; // Client-side key
export const API_SERVER_KEY = 'e3f00ba15ce20035e76790dea94fff2a10460310b4a24421336d64c3a43b7187'; // Server-side key
export const DY_HOST = 'https://direct.dy-api.com'; // Client-side US endpoint
export const DY_SERVER_HOST = 'https://dy-api.com'; // Server-side US endpoint
export const DY_HOST_ENGAGEMENT = 'https://direct-collect.dy-api.com'; // Client-side US endpoint

export const CHOOSE_ENDPOINT = '/v2/serve/user/choose';
export const ENGAGEMENT_ENDPOINT = '/v2/collect/user/engagement';

export const DY_REQUEST_TIMEOUT = 1000;

export const DY_DATA_QUERY_KEY = 'dyData';
export const PROMOTIONS_QUERY_KEY = 'Promotions';

export const TYPE = {
    HOMEPAGE: 'HOMEPAGE',
    CATEGORY: 'CATEGORY',
    PRODUCT: 'PRODUCT',
    CART: 'CART',
    OTHER: 'OTHER',
} as const;

export const DY_SELECTOR = {
    PROMOTION: 'M_HP',
    HP_RECOMMENDATION: 'M - HP - Recommendations',
    CATEGORY_BOTTOM_RECOMMENDATION: 'M - CP - Bottom Recommendations',
};

export const DY_QUERY_KEYS = {
    [DY_SELECTOR.PROMOTION]: PROMOTIONS_QUERY_KEY,
    [DY_SELECTOR.HP_RECOMMENDATION]: DY_DATA_QUERY_KEY,
    [DY_SELECTOR.CATEGORY_BOTTOM_RECOMMENDATION]: DY_DATA_QUERY_KEY,
};

export const DY_CHOOSE_SELECTOR = {
    [TYPE.HOMEPAGE]: [DY_SELECTOR.PROMOTION, DY_SELECTOR.HP_RECOMMENDATION],
    [TYPE.OTHER]: [DY_SELECTOR.CATEGORY_BOTTOM_RECOMMENDATION],
};

export const PREDICTIONS = {
    PREDICT_TO_BUY: 'PTBP',
    PREDICT_TO_BUY_LOW: 'PTBP2',
    PREDICT_TO_BUY_CONTROL: 'PTBP_CONTROL',
    FIRST_DAY_PREMIUM: 'FDPP',
    PREDICT_TO_BUY_LOW_WITHOUT_CATEGORY: 'PTBP_WITHOUT_CATEGORY',
};

export const PREDICTION = {
    key: 'PREDICTION',
    selector: 'PREDICTION',
    type: TYPE.OTHER,
};

export const HP_PROMOTIONS = {
    selector: 'M_HP',
    type: TYPE.HOMEPAGE,
};

export const HP_SHOP_THE_LOOK = {
    selector: 'M - HP - Shop the look',
    type: TYPE.CART,
};

export const WISHLIST_RECOMMENDATION = {
    selector: 'M - Wishlist Recommendations',
    type: TYPE.OTHER,
};

export const HOME_PAGE_RECOMMENDATION = {
    selector: 'M - HP - Recommendations',
    type: TYPE.HOMEPAGE,
};

export const CATEGORY_BOTTOM_RECOMMENDATION = {
    selector: 'M - CP - Bottom Recommendations',
    type: TYPE.CATEGORY,
};

export const CATEGORY_RECENTLY_VIEWED_RECOMMENDATION = {
    selector: 'M - CP - Recently Viewed strip',
    type: TYPE.CATEGORY,
};

export const PRODUCT_RECOMMENDATION = {
    selector: 'M - PDP - Recommendations - 100%',
    type: TYPE.PRODUCT,
};

export const CATEGORY_SIMILAR_FRAMES = {
    selector: 'M - CTP - Similar frames',
    type: TYPE.PRODUCT,
};

export const HOME_PAGE_FIRST_DAY_PREMIUM_RECOMMENDATION = {
    selector: 'M - HP - First Day Premium',
    type: TYPE.HOMEPAGE,
};

export const WISHLIST_SIMILAR_STYLES = {
    selector: 'M - Wishlist - Similar styles',
    type: TYPE.PRODUCT,
};

export const DEFAULT_ANALYTICS_LABEL = 'Control Group';

export const ANALYTICS = {};

export const HOUSE_BRANDS = ['Ottoto', 'Revel', 'Muse', 'Muse x Hilary Duff', 'Amelia E.', 'YOJI'];

export const TRYON_SIMILAR_FRAMES = {
    selector: 'M-TryOn-SimilarFrames',
    type: TYPE.OTHER,
    type_category: TYPE.CATEGORY,
    type_product: TYPE.PRODUCT,
};
